import _ from 'lodash';
import BaseLocation from '../namespaces/location';
import * as postMessage from '../privates/postMessage';
import {validate, validateByType, TYPES} from '../privates/validations/validation';
import {generateError} from '../privates/validations/errors';
import reporter from '../privates/reporter';
import * as members from '../privates/privateMembers';
import platformUtils from '../privates/platformUtils';

const isExternalLink = (linkData) => _.get(linkData, 'type') === 'ExternalLink';

const validateQueryParams = queryParams => {
    if (validateByType({value: queryParams, expectedType: TYPES.OBJECT})) {
        const isValidParam = paramValue => {
            const isValid = validateByType({value: paramValue, expectedType: TYPES.STRING}) || validateByType({value: paramValue, expectedType: TYPES.BOOLEAN});
            if (!isValid) {
                reporter.reportSdkError(generateError.error_navigating_to_section({propertyName: 'query param', type: `${TYPES.STRING} or ${TYPES.BOOLEAN}`}));
            }
            return isValid;
        };
        return _.every(queryParams, param => isValidParam(param));
    }

    reporter.reportSdkError(generateError.error_navigating_to_section({propertyName: 'queryParams', type: TYPES.OBJECT}));
    return false;
};

class Location extends BaseLocation {
    constructor(appDefId) {
        super(appDefId);
        _.bindAll(this, ['navigateTo', 'buildCustomizedUrl']);
    }

    getExternalUrl(linkData) {
        if (isExternalLink(linkData)) {
            return linkData.url;
        }
    }

    navigateTo(linkData) {
        if (!validate({compType: 'Location', functionName: 'navigateTo', dataToValidate: {linkData}})) {
            return;
        }
        if (isExternalLink(linkData)) {
            reporter.reportSdkError(generateError.error_navigating_to_external_url({externalUrl: linkData.url}));
            return;
        }

        if (linkData.hasOwnProperty('pageId')) {
            linkData.pageId = linkData.pageId === '#' ? linkData.pageId : linkData.pageId.replace('#', '');
        }

        if (linkData.hasOwnProperty('target')) {
            delete linkData.target;
        }

        postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
            command: postMessage.MessageTypes.NAVIGATE_TO,
            appDefinitionId: members._appDefId.get(this),
            data: linkData
        });
    }

    navigateToSection(linkData) {
        if (platformUtils.getQueryParameter('viewMode') === 'preview') {
            if (!validate({compType: 'Location', functionName: 'navigateToSection', dataToValidate: {linkData}})) {
                return;
            }

            const {state, sectionId, queryParams, compId} = linkData;
            if (!compId) {
                reporter.reportSdkError(generateError.error_mandatory_val({propertyName: 'compId', functionName: 'navigateToSection'}));
                return;
            }

            if (state && !validateByType({value: state, expectedType: TYPES.STRING})) {
                reporter.reportSdkError(generateError.error_navigating_to_section({propertyName: 'state', type: TYPES.STRING}));
                return;
            }

            if (sectionId && !validateByType({value: sectionId, expectedType: TYPES.STRING})) {
                reporter.reportSdkError(generateError.error_navigating_to_section({propertyName: 'sectionId', type: TYPES.STRING}));
                return;
            }

            if (queryParams && !validateQueryParams(queryParams)) {
                return;
            }

            const appDefinitionId = members._appDefId.get(this);
            linkData.appDefinitionId = appDefinitionId;

            postMessage.sendMessageToHost(postMessage.Intent.TPA, {
                command: postMessage.MessageTypes.NAVIGATE_TO_SECTION,
                appDefinitionId,
                data: {sectionIdentifier: linkData, compId}
            });
        }
    }
    buildCustomizedUrl() {
        return Promise.resolve();
    }
}

export default Location;
